import React, { Component } from 'react';
import { Card, Button, Form, DatePicker } from 'antd';
import moment from 'moment';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.loadDataLocal();
  }

  loadDataLocal = () => {
    const data = [];
    for (let i = 50; i >= 0; i--) {
      data.push({
        key: i,
        compname: `Edward King ${i}`,
        name: 32,
        init: `London. ${i}`,
        current: `Park. ${i}`,
        remark: `Lane. ${i}`,
      });
    }
  };

  companyInfo = () => (
    <Card>
      <Button> 财务统计分析 </Button>
      <Button> 每月财务统计分析 </Button>
      <Button> 利润分析 </Button>
      <Button> 投资现金回报 </Button>
    </Card>
  );

  searchBar = () => {
    const { getFieldDecorator } = this.props.form;
    const dateFormat = 'YYYY-MM-DD';
    return (
      <Form inline onSubmit={this.handleSubmit} style={{ marginBottom: 15 }}>
        <FormItem>
          {getFieldDecorator('company', {
            initialValue: [moment('2015/01/01', dateFormat), moment('2015/01/01', dateFormat)],
          })(<RangePicker format={dateFormat} />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit">
            搜索
          </Button>
        </FormItem>
      </Form>
    );
  };

  render() {
    return (
      <div>
        {this.companyInfo()}
        {this.searchBar()}
      </div>
    );
  }
}

export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/finance/analyze/Index.js